import React, { useEffect, useRef } from 'react';
import './MessageContextMenu.css';

const MessageContextMenu = ({
    position,
    onReply,
    onEdit,
    onForward,
    onDelete,
    onShare,
    onClose,
    canEdit = true,
    canDelete = true
}) => {
    const menuRef = useRef(null);

    // Close on click outside
    useEffect(() => {
        const handleClickOutside = (e) => {
            if (menuRef.current && !menuRef.current.contains(e.target)) {
                onClose();
            }
        };

        const handleEscape = (e) => {
            if (e.key === 'Escape') {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        document.addEventListener('keydown', handleEscape);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
            document.removeEventListener('keydown', handleEscape);
        };
    }, [onClose]);

    // FIX #9: Clamp menu position to viewport bounds
    useEffect(() => {
        if (!menuRef.current) return;
        const rect = menuRef.current.getBoundingClientRect();
        const vw = window.innerWidth;
        const vh = window.innerHeight;
        const style = menuRef.current.style;

        if (rect.right > vw) {
            style.left = `${Math.max(0, vw - rect.width - 8)}px`;
        }
        if (rect.bottom > vh) {
            style.top = `${Math.max(0, vh - rect.height - 8)}px`;
        }
    }, [position]);

    // FIX M-4: Auto-focus first menu item on open
    useEffect(() => {
        if (menuRef.current) {
            const firstItem = menuRef.current.querySelector('[role="menuitem"]');
            firstItem?.focus();
        }
    }, []);

    // FIX M-4: Arrow key navigation
    const handleKeyDown = (e) => {
        const items = menuRef.current?.querySelectorAll('[role="menuitem"]');
        if (!items?.length) return;
        const active = document.activeElement;
        const idx = Array.from(items).indexOf(active);
        if (e.key === 'ArrowDown') {
            e.preventDefault();
            items[(idx + 1) % items.length]?.focus();
        } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            items[(idx - 1 + items.length) % items.length]?.focus();
        }
    };

    return (
        <div
            className="message-context-menu"
            style={{ top: position.y, left: position.x }}
            ref={menuRef}
            role="menu"
            onKeyDown={handleKeyDown}
        >
            <button
                type="button"
                role="menuitem"
                className="message-context-menu__item"
                onClick={() => {
                    onReply();
                    onClose();
                }}
            >
                Reply
            </button>

            {canEdit && (
                <button
                    type="button"
                    role="menuitem"
                    className="message-context-menu__item"
                    onClick={() => {
                        onEdit();
                        onClose();
                    }}
                >
                    Edit
                </button>
            )}

            <button
                type="button"
                role="menuitem"
                className="message-context-menu__item"
                onClick={() => {
                    onForward();
                    onClose();
                }}
            >
                Forward
            </button>

            {onShare && (
                <button
                    type="button"
                    role="menuitem"
                    className="message-context-menu__item"
                    onClick={() => {
                        onShare();
                        onClose();
                    }}
                >
                    Share
                </button>
            )}

            <div className="message-context-menu__divider" />

            {canDelete && (
                <button
                    type="button"
                    role="menuitem"
                    className="message-context-menu__item message-context-menu__item--danger"
                    onClick={() => {
                        onDelete();
                        onClose();
                    }}
                >
                    Delete
                </button>
            )}
        </div>
    );
};

export default MessageContextMenu;
